import { Alert, Link, Tag } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { CheckCircleOutlined } from "@/icons"
import { GITHUB_KEY_PREFIX } from "./GitHubConfigurationPage.constants"

import type { GitHubIssuesPermission } from "@/api/useIntegrations.types"
import type { GitHubIssuesPermissionStatusProps } from "./GitHubConfigurationPage.types"

const MISSING_PERMISSION_KEYS: Partial<Record<GitHubIssuesPermission, string>> =
  {
    PENDING_APPROVAL: "issues.permission.pendingApproval",
    NOT_REQUESTED: "issues.permission.notRequested"
  }

export const GitHubIssuesPermissionStatus = (
  props: GitHubIssuesPermissionStatusProps
) => {
  const { permission, installationUrl } = props
  const { t } = useTranslation("translation", { keyPrefix: GITHUB_KEY_PREFIX })
  const missingKey = MISSING_PERMISSION_KEYS[permission]

  if (permission === "GRANTED")
    return (
      <div>
        <Tag color="green" icon={<CheckCircleOutlined />}>
          {t("issues.permission.granted")}
        </Tag>
      </div>
    )

  if (!missingKey) return null

  return (
    <Alert
      showIcon
      type="warning"
      title={t(missingKey)}
      action={
        <Link target="_blank" href={installationUrl}>
          {t("configureInGithub")}
        </Link>
      }
    />
  )
}
